import { render, staticRenderFns } from "./MessageCardPlain.vue?vue&type=template&id=d2f0d972&scoped=true&"
import script from "./MessageCardPlain.vue?vue&type=script&lang=ts&"
export * from "./MessageCardPlain.vue?vue&type=script&lang=ts&"
import style0 from "./MessageCardPlain.vue?vue&type=style&index=0&id=d2f0d972&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2f0d972",
  null
  
)

export default component.exports